export default {
    LeftMenu: {
        Control: "Control",
        EmployeeList: "Nhân viên",
        CollapseText: "Thu gọn"
    }
}